"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var ReportContext_1 = __importDefault(require("./ReportContext"));
var tableConf_1 = require("./tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.pricingEstimateConf);
var Row = (0, RowMaker_1.default)(tableConf_1.pricingEstimateConf);
var VendorsQuote = function (_a) {
    var _b, _c, _d;
    var quoteReport = _a.quoteReport;
    var _e = __read(react_1.default.useState('dollar'), 2), type = _e[0], setType = _e[1];
    var contextValue = react_1.default.useMemo(function () { return ({ type: type }); }, [type]);
    var plansReportRows = (_b = quoteReport.planIds) === null || _b === void 0 ? void 0 : _b.map(function (pId) { return quoteReport.reportRowsMap[pId] && __assign({ id: pId }, quoteReport.reportRowsMap[pId]); }).filter(end2end_1.notFalsy);
    var addOnRows = (_c = quoteReport.addOnIds) === null || _c === void 0 ? void 0 : _c.map(function (aOId) { return quoteReport.reportRowsMap[aOId] && __assign({ id: aOId }, quoteReport.reportRowsMap[aOId]); }).filter(end2end_1.notFalsy);
    var oneTimeFeeRows = (_d = quoteReport.oneTimeFeeIds) === null || _d === void 0 ? void 0 : _d.map(function (aOId) { return quoteReport.reportRowsMap[aOId] && __assign({ id: aOId }, quoteReport.reportRowsMap[aOId]); }).filter(end2end_1.notFalsy);
    return ((0, jsx_runtime_1.jsx)(ReportContext_1.default.Provider, __assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: "100%", height: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 1 }, { children: "Vendor\u2019s Quote" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: function () { return setType(type === 'percent' ? 'dollar' : 'percent'); }, size: "small" }, { children: "Change Graph Type" }))] })), (0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsxs)(TableBody_1.default, { children: [plansReportRows === null || plansReportRows === void 0 ? void 0 : plansReportRows.map(function (plan) { return (0, jsx_runtime_1.jsx)(Row, { item: plan }, plan.id); }), addOnRows === null || addOnRows === void 0 ? void 0 : addOnRows.map(function (plan) { return (0, jsx_runtime_1.jsx)(Row, { item: plan }, plan.id); }), oneTimeFeeRows === null || oneTimeFeeRows === void 0 ? void 0 : oneTimeFeeRows.map(function (plan) { return (0, jsx_runtime_1.jsx)(Row, { item: plan }, plan.id); })] })] })] })) })));
};
exports.default = VendorsQuote;
